import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/dados-historicos')({
  component: lazyRouteComponent(
    () => import('@/features/historico/components/historico-page'),
    'HistoricoPage'
  ),
})
